export const capitalize = str => {
  return str.replace(/\w/, firstLetter => firstLetter.toUpperCase())
}

export const camelize = str => {
  return str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ''
    return index === 0 ? match.toLowerCase() : match.toUpperCase()
  })
}

export const toKebabCase = str => str.replace(' ', '-').toLowerCase()
